import { gql } from '@apollo/client';

export const CREATE_SHORTFALL = gql`
  mutation createShortfall($formInstanceId: ID!, $remark: String = "") {
    createShortfall(formInstanceId: $formInstanceId, remark: $remark)
  }
`;
